import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';

@NgModule({
  imports: [
  ],
  exports: [RouterModule]
})
export class AuthRoutingModule {}
